"use client";

import Script from "next/script";
import { useEffect } from "react";

import { usePathname } from "@/lib/i18n";

export default function TrengoScript() {
  const pathname = usePathname();

  useEffect(() => {
    if (typeof document !== "undefined") {
      const change = () => {
        const div = document.getElementById("trengo-web-widget");
        if (
          ![
            "/",
            "/reset-password",
            "/inneos",
            "/kevin",
            "/lifetime-offer",
            "/market",
            "/trump",
            "/checkout",
          ].includes(pathname)
        ) {
          if (div) {
            div.classList.add("!opacity-0");
          } else
            setTimeout(() => {
              change();
            }, 1000);
        } else {
          if (div) {
            div.classList.remove("!opacity-0");
          } else
            setTimeout(() => {
              change();
            }, 1000);
        }
      };

      change();
    }
  }, [pathname]);

  return (
    <Script id="trengo" strategy="lazyOnload" defer async>
      {`window.Trengo = window.Trengo || {};
        window.Trengo.key = 'zkti2lr2oGjicZf5A0wr';
        (function(d, script, t) {
            script = d.createElement('script');
            script.type = 'text/javascript';
            script.async = true;
            script.id = 'trengo-script';
            script.src = 'https://static.widget.trengo.eu/embed.js';
            d.getElementsByTagName('head')[0].appendChild(script);
        }(document));`}
    </Script>
  );
}
